import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from '@mui/material';

import type { CodingResult } from 'src/types/dashboard';

import { styles } from './index.styles';

export interface InsightWheelLegendProps {
  toggleButtonGroupValue: CodingResult[];
  onLegendTopicClick: (
    e: React.MouseEvent<HTMLElement>,
    topic: CodingResult,
  ) => void;
  codingResults: CodingResult[];
}

const InsightWheelLegend: FC<InsightWheelLegendProps> = ({
  toggleButtonGroupValue,
  onLegendTopicClick,
  codingResults,
}) => {
  const { t } = useTranslation('dashboard');

  return (
    <>
      <Box sx={{ pb: 3.25 }}>
        <Typography component="span" variant="h3" sx={{ fontWeight: 'bold' }}>
          {t('InsightWheel.Topics')}
        </Typography>
      </Box>
      <Box sx={{ pl: 2, width: '100%' }}>
        <ToggleButtonGroup
          value={toggleButtonGroupValue}
          orientation="vertical"
          fullWidth
        >
          {codingResults.map((topic, i) => (
            <ToggleButton
              sx={styles.legendTopicButton(topic)}
              fullWidth
              key={i}
              value={topic.categoryLabel}
              onClick={(e) => onLegendTopicClick(e, topic)}
              selected={
                !!toggleButtonGroupValue.find(
                  ({ categoryLabel }) =>
                    categoryLabel.toLowerCase() ===
                    topic.categoryLabel.toLowerCase(),
                )
              }
            >
              <Typography
                variant="caption"
                title={topic.categoryLabel}
                sx={{
                  lineHeight: '16px',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
              >
                {topic.categoryLabel}
              </Typography>
            </ToggleButton>
          ))}
        </ToggleButtonGroup>
      </Box>
    </>
  );
};

export default InsightWheelLegend;
